module.exports = __webpack_public_path__ + "static/media/fashionimg.2bb82e01.png";